// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nAg-","question":"styles_question__r3KY1","description":"styles_description__3wqYj"};